export enum PostStatus {
    ALL = 'ALL',
    DRAFT = 'DRAFT',
    PUBLISHED = 'PUBLISHED'
}